import React, { useState, useEffect } from 'react';
import { postReviewReaction } from '../../../../services/reviewRating';

const renderStars = (count) => {
  return [...Array(5)].map((_, i) => (
    <i key={i} className={`bi ${i < count ? 'bi-star-fill filled-star' : 'bi-star empty-star'}`}></i>
  ));
};

const ReviewCard = ({ review }) => {
  const [expanded, setExpanded] = useState(false);
  const [reactions, setReactions] = useState(review.reactions);
  const [userReaction, setUserReaction] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('review_reactions') || '{}');
    if (stored[review.id]) {
      setUserReaction(stored[review.id]);
    }
  }, [review.id]);

  const handleReaction = async (type) => {
    if (loading) return;

    setLoading(true);

    const stored = JSON.parse(localStorage.getItem('review_reactions') || '{}');
    const isSameReaction = userReaction === type;

    // Determine new reaction type
    const newReaction = isSameReaction ? null : type;

    try {
      const response = await postReviewReaction(review.id, newReaction);

      // Save or remove from localStorage
      if (newReaction) {
        stored[review.id] = newReaction;
      } else {
        delete stored[review.id];
      }

      localStorage.setItem('review_reactions', JSON.stringify(stored));
      setUserReaction(newReaction);

      // Refresh count from backend response
      setReactions({
        like_count: response.like_count,
        dislikes_count: response.dislike_count
      });
       window.location.reload();
    } catch (err) {
      console.error('Error submitting reaction', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-card">
      <div className="review-top">
        <div className="user-info-left">
          <img src={review.img || 'https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg'} alt={review.name ||"Review img"} className="user-img" />
          <div>
            <strong>{review.name}</strong>
            <p className="review-date">{review.date}</p>
          </div>
        </div>
        <div className="review-stars">{renderStars(review.rating)}</div>
      </div>

      <p className={`user-comment ${expanded ? 'expanded' : 'collapsed'}`}>
        {review.comment}
      </p>
      {review.comment.length > 300 && (
        <span className="toggle-more" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Show less' : 'Show more'}
        </span>
      )}

      <div className="review-bottom">
        <div className="thumbs">
          <i
            className={`bi bi-hand-thumbs-down ${userReaction === 'dislike' ? 'text-primary' : ''}`}
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
            onClick={() => handleReaction('dislike')}
          ></i>
          <span>{reactions?.dislikes_count || 0}</span>

          <i
            className={`bi bi-hand-thumbs-up ms-3 ${userReaction === 'like' ? 'text-primary' : ''}`}
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
            onClick={() => handleReaction('like')}
          ></i>
          <span>{reactions?.like_count || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
